'use strict';

var react = require('react');

const useFocus = () => {
    const ref = react.useRef();
    const [focused, setIsFocused] = react.useState(false);
    const callbackReference = react.useCallback((node) => {
        const handleFocus = () => setIsFocused(true);
        const handleBlur = () => setIsFocused(false);
        if (ref.current) {
            ref.current.removeEventListener('focus', handleFocus);
            ref.current.removeEventListener('blur', handleBlur);
        }
        ref.current = node;
        if (ref.current) {
            ref.current.addEventListener('focus', handleFocus);
            ref.current.addEventListener('blur', handleBlur);
        }
    }, []);
    return [callbackReference, focused];
};

exports.useFocus = useFocus;
//# sourceMappingURL=useFocus.js.map
